import Tool, {
  type IToolActionInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import Shortcut from '../utils/Shortcut';
import { isSimpleSelection } from '../objects/guards';

class ToolGroup extends Tool {
  static toolName = 'Group objects';
  static shortcut = new Shortcut('Cmd+G');

  static action({ controller, selection }: IToolActionInput) {
    if (!isSimpleSelection(selection)) {
      console.warn('Cannot group, not a valid selection');
      return;
    }

    const newGroup = selection.toGroup();
    if (newGroup) {
      newGroup.created(controller);
    }

    // Force object toolbar to update.
    controller.actionShowObjectToolbar();
    this.toolActionComplete({ controller });
  }

  static enabled({ selection }: IToolEnabledInput) {
    return !!(
      selection &&
      !selection.isLocked &&
      isSimpleSelection(selection) &&
      selection.size() > 1
    );
  }

  static buttonComponent() {
    return simpleToolButton(ToolGroup, 'fa-regular fa-object-group');
  }
}

export default ToolGroup;
